import { render, staticRenderFns } from "./ApplicantEmergencyContacts.vue?vue&type=template&id=a77a0246&scoped=true&"
import script from "./ApplicantEmergencyContacts.vue?vue&type=script&lang=js&"
export * from "./ApplicantEmergencyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a0246",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a77a0246')) {
      api.createRecord('a77a0246', component.options)
    } else {
      api.reload('a77a0246', component.options)
    }
    module.hot.accept("./ApplicantEmergencyContacts.vue?vue&type=template&id=a77a0246&scoped=true&", function () {
      api.rerender('a77a0246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantEmergencyContacts.vue"
export default component.exports